import type {
  BaseProp,
  ChildrenProp,
} from "@circle-react-shared/BuilderUI/DataModel.types";
import type {
  StyleValue,
  StylesProp,
} from "@circle-react-shared/BuilderUI/StyleValue.types";

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const isStyleValue = (value: unknown): value is StyleValue =>
  isRecord(value) && typeof value.type === "string" && "value" in value;

export const isStylesProp = (prop: BaseProp | StylesProp): prop is StylesProp =>
  prop?.type === "styles" && isRecord(prop.value);

export const isChildrenProp = (
  prop: BaseProp | StylesProp,
): prop is ChildrenProp => prop.type === "children";
